import { createRoot } from "react-dom/client";
import CalendarPage from "../components/Calendar/App";

/**
 * Front Page
 */
const PageCalendar = ($) => {
	if ($("body").hasClass("page-template-calendar")) {
		const calendarRootElement = document.getElementById("js--calendar");
		const props = { ...(calendarRootElement && calendarRootElement.dataset)}
		const calendarRoot = createRoot(calendarRootElement);
		calendarRoot.render(<CalendarPage {...props} />);
	}
};

export default PageCalendar;
